import { TeamNanoID } from '../../../../../../teams/teamsTypes';
import {
  FETCH_CACHE_BILLING_INFOS_QUERY,
  FetchCacheBillingInfosQueryResponse
} from '../../../../../../billingInfos/queries/fetchCacheBillingInfos.query';

import { useCachePaginatedBillingInfos } from '../../../../../../billingInfos/hooks/useCachePaginatedBillingInfos';

import { BillingInfoCache } from '../../../../../../billingInfos/BillingInfoCache';

interface AddFundsModalButtonBillingInfosOptions {
  companyNanoId: TeamNanoID;
}

function useAddFundsModalButtonBillingInfos({
  companyNanoId
}: AddFundsModalButtonBillingInfosOptions) {
  const { billingInfos, billingInfosLoading, billingInfosErrorMessage } =
    useCachePaginatedBillingInfos<FetchCacheBillingInfosQueryResponse>({
      cacheKey: BillingInfoCache.addFundsCacheKey(companyNanoId),
      initialLimit: 1000,
      initialFilters: {
        companyNanoId: { eq: companyNanoId }
      },
      query: FETCH_CACHE_BILLING_INFOS_QUERY
    });

  return {
    billingInfos,
    billingInfosErrorMessage,
    billingInfosLoading
  };
}

export default useAddFundsModalButtonBillingInfos;
